import React from "react";
import DemoAccountManagement from "./DemoAccountManagement";

export default function DemoAccountsTab() {
    return (
        <div className="max-w-4xl mx-auto space-y-6">
            <div>
                <h1 className="text-2xl font-bold text-gray-900">Accounts</h1>
                <p className="text-gray-500 mt-1">Manage your linked financial accounts</p>
            </div>

            <DemoAccountManagement />
        </div>
    );
}
